import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100 mt-16">
      <div className="max-w-portal mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded bg-accent-500 text-background-50 font-heading font-black text-lg">
                黑
              </span>
              <span className="font-heading text-xl font-black tracking-tight">黑料八卦</span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              收录综艺、影视、节目与剧组的幕后见闻。拍摄现场发生了什么、剪辑台剪掉了什么，
              我们负责补全镜头之外的剧情。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-bilibili-line", label: "B站" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((item) => (
                <a
                  key={item.label}
                  href="/about#contact"
                  aria-label={item.label}
                  rel="nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-secondary-800 text-background-200 hover:bg-primary-500 hover:text-foreground-950 transition-colors cursor-pointer"
                >
                  <i className={`${item.icon} text-lg`} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">内容分类</h3>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base font-bold text-background-50 mb-4">关于本站</h3>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about#principles"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  内容原则
                </Link>
              </li>
              <li>
                <Link
                  to="/about#contact"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  联系与投稿
                </Link>
              </li>
              <li>
                <Link
                  to="/#faq"
                  className="text-sm text-background-300 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  常见问题
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            © {year} 黑料八卦 · 内容基于公开制作信息整理，仅供交流参考
          </p>
          <p className="text-xs text-background-400 inline-flex items-center gap-1.5">
            <i className="ri-mail-send-line w-3.5 h-3.5 flex items-center justify-center" />
            投稿与合作：hello@heiliao-bagua.example
          </p>
        </div>
      </div>
    </footer>
  );
}